import { __extends } from "tslib";
import { PutRecordInput, PutRecordOutput } from "../models/models_0";
import { deserializeAws_json1_1PutRecordCommand, serializeAws_json1_1PutRecordCommand } from "../protocols/Aws_json1_1";
import { getSerdePlugin } from "@aws-sdk/middleware-serde";
import { Command as $Command } from "@aws-sdk/smithy-client";
var PutRecordCommand = /** @class */ (function (_super) {
    __extends(PutRecordCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function PutRecordCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    PutRecordCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "FirehoseClient";
        var commandName = "PutRecordCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: PutRecordInput.filterSensitiveLog,
            outputFilterSensitiveLog: PutRecordOutput.filterSensitiveLog,
        };
        if (typeof logger.info === "function") {
            logger.info({
                clientName: clientName,
                commandName: commandName,
            });
        }
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    PutRecordCommand.prototype.serialize = function (input, context) {
        return serializeAws_json1_1PutRecordCommand(input, context);
    };
    PutRecordCommand.prototype.deserialize = function (output, context) {
        return deserializeAws_json1_1PutRecordCommand(output, context);
    };
    return PutRecordCommand;
}($Command));
export { PutRecordCommand };
//# sourceMappingURL=PutRecordCommand.js.map